import React from 'react';
import { ToggleButton } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import './Checkbox.css';

type CheckboxProps = {
  id?: string;
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  dimensions?: 'sm' | 'lg';
  onChange?: (checked: boolean) => void;
};

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label = '',
  checked = false, // Use checked instead of defaultChecked
  onChange,
  disabled = false,
  dimensions = 'sm',
}) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    if (onChange) {
      onChange(isChecked);
    }
  };
  return (
    <div className="checkbox-container">
      <ToggleButton
        size={dimensions}
        id={id ?? ''}
        type="checkbox"
        checked={checked}
        onChange={handleCheckboxChange}
        className={checked ? 'checkbox-checked' : 'checkbox-unchecked'} // Use checked prop directly
        value={''}
        disabled={disabled}
      >
        <FaCheck />
      </ToggleButton>
      <span className="checkbox-label">{label}</span>
    </div>
  );
};

export default Checkbox;
